const ENVIRONMENT = {
  DEV: 'https://cdn.dev.apps.calibrantenergy.net',
  PRD: 'https://cdn.apps.calibrantenergy.com',
};

export function getEnvironmentUrl() {
  let cdnURL = ENVIRONMENT.DEV;
  if (window.location.href.search('.predev.apps.calibrantenergy.net') !== -1) {
    cdnURL = ENVIRONMENT.DEV;
  }
  if (window.location.href.search('.soak.apps.calibrantenergy.net') !== -1) {
    cdnURL = ENVIRONMENT.DEV;
  }
  if (window.location.href.search('.beta.apps.calibrantenergy.com') !== -1) {
    cdnURL = ENVIRONMENT.PRD;
  } else if (window.location.href.search('.apps.calibrantenergy.com') !== -1) {
    cdnURL = ENVIRONMENT.PRD;
  }
  return cdnURL;
}
